import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AppLayout } from "@/components/layout/app-layout";
import { useAuth } from "@/hooks/use-auth";
import { CompaniesPage } from "@/pages/companies";
import { CompanyDetailPage } from "@/pages/company-detail";
import { LoginPage } from "@/pages/login";
import { MembersPage } from "@/pages/members";
import { OverviewPage } from "@/pages/overview";
import { ResetPasswordPage } from "@/pages/reset-password";
import { ProductsPage } from "@/pages/products";
import { ProfileCardPage } from "@/pages/profile-card";
import { SamplesPage } from "@/pages/samples";
import { TasksPage } from "@/pages/tasks";

export function AppRoutes() {
  const { isSignedIn } = useAuth();

  return (
    <BrowserRouter>
      <Routes>
        {!isSignedIn ? (
          <>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/reset" element={<ResetPasswordPage />} />
            {/* Anything else while signed out lands on login. */}
            <Route path="*" element={<Navigate to="/login" replace />} />
          </>
        ) : (
          <>
            <Route path="/login" element={<Navigate to="/" replace />} />
            {/* Reachable while signed in too: somebody who followed the link
                from their inbox may already have a session open here. */}
            <Route path="/reset" element={<ResetPasswordPage />} />
            <Route element={<AppLayout />}>
              <Route path="/" element={<OverviewPage />} />
              <Route path="/companies" element={<CompaniesPage />} />
              <Route path="/companies/:id" element={<CompanyDetailPage />} />
              <Route path="/products" element={<ProductsPage />} />
              <Route path="/samples" element={<SamplesPage />} />
              <Route path="/tasks" element={<TasksPage />} />
              <Route path="/members" element={<MembersPage />} />
              <Route path="/card" element={<ProfileCardPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </>
        )}
      </Routes>
    </BrowserRouter>
  );
}
